(function () {
  try {
    if (!/\/products\/three-panel-fleece-hoodie\/?$/.test(location.pathname)) return;

    var prefer = 'Blue Mist';
    var params = new URLSearchParams(location.search);
    var urlVariant = params.get('variant');

    function clickBlueMist() {
      var radio = document.querySelector(
        'variant-picker input[type="radio"][value="' + prefer + '"]'
      );
      if (radio) {
        if (!radio.checked) radio.click();
        return true;
      }
      var opt = document.querySelector(
        'variant-picker select option[value="' + prefer + '"]'
      );
      if (opt && opt.parentElement) {
        if (opt.parentElement.value !== prefer) {
          opt.parentElement.value = prefer;
          opt.parentElement.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return true;
      }
      return false;
    }

    function applyPrefer(force) {
      if (!force) return;
      if (clickBlueMist()) return;
      fetch('/products/three-panel-fleece-hoodie.js')
        .then(function (r) { return r.json(); })
        .then(function (p) {
          var v = (p.variants || []).find(function (x) {
            return x.option2 === prefer && x.available;
          });
          if (!v) return;
          if (!clickBlueMist()) {
            location.replace(location.pathname + '?variant=' + v.id + location.hash);
          }
        })
        .catch(function () {});
    }

    function shouldForce(cb) {
      // No variant in URL → always Blue Mist default
      if (!urlVariant) {
        cb(true);
        return;
      }
      // Explicit non-Black color share → honor
      fetch('/products/three-panel-fleece-hoodie.js')
        .then(function (r) { return r.json(); })
        .then(function (p) {
          var v = (p.variants || []).find(function (x) {
            return String(x.id) === String(urlVariant);
          });
          // Printify resets Black-first; treat Black URL (and missing) as default to override
          var color = v && (v.option2 || '');
          cb(!color || color === 'Black');
        })
        .catch(function () {
          cb(true);
        });
    }

    shouldForce(function (force) {
      if (!force) return;
      applyPrefer(true);
      var n = 0;
      var timer = setInterval(function () {
        n += 1;
        if (clickBlueMist() || n > 25) clearInterval(timer);
      }, 120);
    });
  } catch (e) {}
})();
